import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bsc-data-science',
  templateUrl: './bsc-data-science.component.html',
  styleUrls: ['./bsc-data-science.component.scss']
})
export class BscDataScienceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
